var map = {
	"./bianchi_1.png": 5536,
	"./bianchi_2.png": 6972,
	"./bianchi_3.png": 4551,
	"./bianchi_4.png": 7446,
	"./bianchi_5.png": 8403,
	"./bianchi_6.png": 1701,
	"./default.png": 4162,
	"./image.png": 4490,
	"./liquori_1.png": 3838,
	"./liquori_2.png": 349,
	"./liquori_3.png": 1503,
	"./liquori_4.png": 3208,
	"./logo.png": 9539,
	"./olio_1.png": 4729,
	"./olio_2.png": 8137,
	"./olio_3.png": 9532,
	"./rosati_1.png": 8445,
	"./rossi_1.png": 8558,
	"./rossi_2.png": 5460,
	"./rossi_3.png": 7614,
	"./rossi_4.png": 107,
	"./spumanti_1.png": 4633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5813;